// extracted by mini-css-extract-plugin
module.exports = {"currentIndicator":"CurrentIndicator_currentIndicator__2KCfA"};